// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dRational$dSerialized from "../Data.Rational.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dVatRate from "../Restaumatic.Menu.V2.Types.VatRate/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ContainedId = (tag, _1, _2) => ({tag, _1, _2});
const eq = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq3 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq)();
const eq5 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") {
      if (x._1.tag === "VatA") { return y._1.tag === "VatA"; }
      if (x._1.tag === "VatB") { return y._1.tag === "VatB"; }
      if (x._1.tag === "VatC") { return y._1.tag === "VatC"; }
      if (x._1.tag === "VatD") { return y._1.tag === "VatD"; }
      if (x._1.tag === "VatE") { return y._1.tag === "VatE"; }
      if (x._1.tag === "VatF") { return y._1.tag === "VatF"; }
      if (x._1.tag === "VatG") { return y._1.tag === "VatG"; }
      if (x._1.tag === "VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption") { return y._1.tag === "VatSkPreparedOrUnpreparedFoodIntendedForHumanConsumption"; }
      if (x._1.tag === "VatSkNonAlcoholicBeveragesIntendedForHumanConsumption") { return y._1.tag === "VatSkNonAlcoholicBeveragesIntendedForHumanConsumption"; }
      if (x._1.tag === "VatSkAlcoholicBeveragesIntendedForHumanConsumption") { return y._1.tag === "VatSkAlcoholicBeveragesIntendedForHumanConsumption"; }
      if (x._1.tag === "VatSkSeparateFoodPackaging") { return y._1.tag === "VatSkSeparateFoodPackaging"; }
      if (x._1.tag === "VatSkTransport") { return y._1.tag === "VatSkTransport"; }
      if (x._1.tag === "VatSkWithout") { return y._1.tag === "VatSkWithout"; }
      if (x._1.tag === "VatSkExempt") { return y._1.tag === "VatSkExempt"; }
      return false;
    }
    return false;
  }
  return false;
};
const allowedContainersIsSymbol = {reflectSymbol: () => "allowedContainers"};
const volumeIsSymbol = {reflectSymbol: () => "volume"};
const showArray = {show: /* #__PURE__ */ Data$dShow.showArrayImpl(Data$dUUID.toString)};
const PackagingContainersConfigIsSymbol = {reflectSymbol: () => "PackagingContainersConfig"};
const decodeArray1 = /* #__PURE__ */ (() => ({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)}))();
const capacityIsSymbol = {reflectSymbol: () => "capacity"};
const enabledIsSymbol = {reflectSymbol: () => "enabled"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const priceIsSymbol = {reflectSymbol: () => "price"};
const vatRateIsSymbol = {reflectSymbol: () => "vatRate"};
const PackagingContainerIsSymbol = {reflectSymbol: () => "PackagingContainer"};
const ProductIdIsSymbol = {reflectSymbol: () => "ProductId"};
const genericShowArgsArgument = {genericShowArgs: v => [v]};
const ModifierItemIdIsSymbol = {reflectSymbol: () => "ModifierItemId"};
const genericDecodeManyArgsArgu = {
  argsDecoder: /* #__PURE__ */ Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(Data$dArray.unsafeIndexImpl(array, offset)))
};
const encodeWithOptionsOther = {encodeWithOptions: v => Data$dRational$dSerialized.encodeRational.encode};
const encodeWithOptionsOther1 = /* #__PURE__ */ (() => {
  const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
  return {encodeWithOptions: v => encode1};
})();
const genericEncodeArgsArgument = {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)};
const decodeWithOptionsOther = {decodeWithOptions: v => Data$dRational$dSerialized.decodeRational.decode};
const decodeWithOptionsOther1 = /* #__PURE__ */ (() => {
  const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
  return {decodeWithOptions: v => decode2};
})();
const genericDecodeArgsArgument = {
  decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
  decodeSingleRecordArg: Data$dMaybe.Nothing
};
const PackagingContainersConfig = x => x;
const PackagingContainer = x => x;
const ProductId = value0 => $ContainedId("ProductId", value0);
const ModifierItemId = value0 => value1 => $ContainedId("ModifierItemId", value0, value1);
const toFillFormTypePackagingCo = {fillFormDataType: v => "unknown"};
const toFillFormTypePackagingCo1 = {fillFormDataType: v => "unknown"};
const toFillFormTypeContainedId = {fillFormDataType: v => "unknown"};
const newtypePackagingContainer = {Coercible0: () => {}};
const newtypePackagingContainer1 = {Coercible0: () => {}};
const hasFieldPackagingContaine = dictHasField => dictHasField;
const hasFieldPackagingContaine1 = dictHasField => dictHasField;
const eqPackagingContainersConf = {eq: x => y => eq(x.allowedContainers)(y.allowedContainers) && x.volume._1 === y.volume._1 && x.volume._2 === y.volume._2};
const eqPackagingContainer = {
  eq: x => y => x.capacity._1 === y.capacity._1 && x.capacity._2 === y.capacity._2 && x.enabled === y.enabled && eq3(x.name)(y.name) && x.price === y.price && eq5(x.vatRate)(y.vatRate)
};
const eqContainedId = {
  eq: x => y => {
    if (x.tag === "ProductId") {
      if (y.tag === "ProductId") { return eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "ModifierItemId") {
      if (y.tag === "ModifierItemId") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    return false;
  }
};
const genericPackagingContainersConfig = {to: x => x, from: x => x};
const showPackagingContainersConfig = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ allowedContainers: " + showArray.show(v.allowedContainers) + ", volume: " + Data$dShow.showIntImpl(v.volume._1) + " % " + Data$dShow.showIntImpl(v.volume._2) + " " + "}"
      ]
    })(PackagingContainersConfigIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodePackagingContainersConfig = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(allowedContainersIsSymbol)(decodeArray1)(Unscramble.decodeRecordCons(volumeIsSymbol)(Data$dRational$dSerialized.udecodeRational)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericPackagingContainer = {to: x => x, from: x => x};
const showPackagingContainer = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      return {
        genericShowArgs: v => [
          "{ capacity: " + Data$dShow.showIntImpl(v.capacity._1) + " % " + Data$dShow.showIntImpl(v.capacity._2) + (v.enabled
            ? ", enabled: true, name: " + $0.show(v.name) + ", price: " + Data$dMoney$dRounded.toString(v.price) + (() => {
                if (v.vatRate.tag === "Just") { return ", vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") "; }
                if (v.vatRate.tag === "Nothing") { return ", vatRate: Nothing "; }
                $runtime.fail();
              })()
            : ", enabled: false, name: " + $0.show(v.name) + ", price: " + Data$dMoney$dRounded.toString(v.price) + (() => {
                if (v.vatRate.tag === "Just") { return ", vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") "; }
                if (v.vatRate.tag === "Nothing") { return ", vatRate: Nothing "; }
                $runtime.fail();
              })()) + "}"
        ]
      };
    })())(PackagingContainerIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodePackagingContainer = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(capacityIsSymbol)(Data$dRational$dSerialized.udecodeRational)(Unscramble.decodeRecordCons(enabledIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(nameIsSymbol)(Restaumatic$dI18n$dTypes.decodeMap(Unscramble.decodeString1))(Unscramble.decodeRecordCons(priceIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(vatRateIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dVatRate.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericContainedId = {
  to: x => {
    if (x.tag === "Inl") { return $ContainedId("ProductId", x._1); }
    if (x.tag === "Inr") { return $ContainedId("ModifierItemId", x._1._1, x._1._2); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ProductId") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "ModifierItemId") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Product(x._1, x._2)); }
    $runtime.fail();
  }
};
const showContainedId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [showArray.show(v)]})(ProductIdIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct(genericShowArgsArgument)(genericShowArgsArgument))(ModifierItemIdIsSymbol);
    return x => {
      if (x.tag === "ProductId") { return $0["genericShow'"](x._1); }
      if (x.tag === "ModifierItemId") { return $1["genericShow'"](Data$dGeneric$dRep.$Product(x._1, x._2)); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeContainedId = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ProductIdIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => decodeArray1.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd(genericDecodeManyArgsArgu)(genericDecodeManyArgsArgu)))(ModifierItemIdIsSymbol)))(Unscramble$dGeneric.defaultOptions);
    return x => genericContainedId.to($0(x));
  })()
};
const encodePackagingContainersConfig = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPackagingContainersConfig)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(PackagingContainersConfigIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(volumeIsSymbol)(encodeWithOptionsOther))(allowedContainersIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodePackagingContainer = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPackagingContainer)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(PackagingContainerIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(vatRateIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dVatRate.encodeVatRate.encode(v2._1); }
        $runtime.fail();
      }
    }))(priceIsSymbol)({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))(nameIsSymbol)((() => {
      const encode1 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode).encode;
      return {encodeWithOptions: v => encode1};
    })()))(enabledIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(capacityIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeContainedId = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericContainedId)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductIdIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeWithOptionsOther1.encodeWithOptions(opts)(v)), Data$dList$dTypes.Nil)
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(ModifierItemIdIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct(genericEncodeArgsArgument)(genericEncodeArgsArgument));
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const decodePackagingContainersConfig = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPackagingContainersConfig)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PackagingContainersConfigIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(volumeIsSymbol)(decodeWithOptionsOther)())(allowedContainersIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodePackagingContainer = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPackagingContainer)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PackagingContainerIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(vatRateIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dVatRate.decodeVatRate.decode)
  })())(priceIsSymbol)({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())(nameIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())(enabledIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode})())(capacityIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeContainedId = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericContainedId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductIdIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther1),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ModifierItemIdIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct(genericDecodeArgsArgument)(genericDecodeArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument))))
};
export {
  $ContainedId,
  ModifierItemId,
  ModifierItemIdIsSymbol,
  PackagingContainer,
  PackagingContainerIsSymbol,
  PackagingContainersConfig,
  PackagingContainersConfigIsSymbol,
  ProductId,
  ProductIdIsSymbol,
  allowedContainersIsSymbol,
  capacityIsSymbol,
  decodeArray1,
  decodeContainedId,
  decodePackagingContainer,
  decodePackagingContainersConfig,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  enabledIsSymbol,
  encodeContainedId,
  encodePackagingContainer,
  encodePackagingContainersConfig,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  eq,
  eq3,
  eq5,
  eqContainedId,
  eqPackagingContainer,
  eqPackagingContainersConf,
  genericContainedId,
  genericDecodeArgsArgument,
  genericDecodeManyArgsArgu,
  genericEncodeArgsArgument,
  genericPackagingContainer,
  genericPackagingContainersConfig,
  genericShowArgsArgument,
  hasFieldPackagingContaine,
  hasFieldPackagingContaine1,
  nameIsSymbol,
  newtypePackagingContainer,
  newtypePackagingContainer1,
  priceIsSymbol,
  showArray,
  showContainedId,
  showPackagingContainer,
  showPackagingContainersConfig,
  toFillFormTypeContainedId,
  toFillFormTypePackagingCo,
  toFillFormTypePackagingCo1,
  unscrambleDecodeContainedId,
  unscrambleDecodePackagingContainer,
  unscrambleDecodePackagingContainersConfig,
  vatRateIsSymbol,
  volumeIsSymbol
};
